import React from 'react'
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary'
import ErrorComponent from './ErrorComponent'
import useLogger from '../BasketPage/Hooks/useLogger'

const MyFallbackComponent = ({ error, resetErrorBoundary, errorInfo }) => {
    return (
        <ErrorComponent
            error={error}
            errorInfo={errorInfo}
            resetErrorBoundary={resetErrorBoundary}
        />
    )
}

const ErrorBoundary = ({ children }) => {
    const { logError } = useLogger()

    const myErrorHandler = (error, errorInfo) => {
        const lines = errorInfo.componentStack.split('\n').map(line => line.trim()).filter(line => line !== '')
        const firstLine = lines[0] || ''
        logError(`${error} ${firstLine}`)
    }

    return (
        <ReactErrorBoundary
            FallbackComponent={MyFallbackComponent}
            onError={myErrorHandler}
        >
            {children}
        </ReactErrorBoundary>
    )
}

export default ErrorBoundary


